import { BlogShared } from './../../general/shared/blog-shared';
import { SnackBarService } from './../../../data/repository/utils-repository/snack-bar.service';
import { BlogService } from 'src/app/data/repository/blog-repository/blog.service';
import { LoadingShared } from './../../general/shared/loading-shared';
import { BlogUserModel } from './../../../core/model/object/blog-user-model';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-blog-follow-requests',
  templateUrl: './blog-follow-requests.component.html',
  styleUrls: ['./blog-follow-requests.component.scss'],
})
export class BlogFollowRequestsComponent implements OnInit {
  @Input() requests: BlogUserModel[];
  @Input() id: number;

  requestCount = 0;
  requestPage = 0;
  requestPerPage = 20;

  selectedUsername = '';
  profileId = 11;
  showProfile = false;

  constructor(
    private loadingShared: LoadingShared,
    private blogService: BlogService,
    private snackBarService: SnackBarService,
    private blogShared: BlogShared
  ) {}

  ngOnInit() {}

  load() {
    this.loadingShared.showLoading();
    this.blogService.getFollowRequests(0, 20).then((result) => {
      if (result.isSuccess()) {
        this.requests = result.getData().getBlogFollowRequests().followers;
        this.requestCount = result.getData().getBlogFollowRequests().count;
      } else {
        this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
      }
      this.loadingShared.hideLoading();
    });
  }

  showMoreRequests() {
    this.loadingShared.showLoading();
    this.requestPage++;
    this.blogService
      .getFollowRequests(this.requestPage, this.requestPerPage)
      .then((res) => {
        if (res.isSuccess()) {
          this.requests = [
            ...this.requests,
            ...res.getData().getBlogFollowRequests().followers,
          ];
          this.requestCount = res.getData().getBlogFollowRequests().count;
        } else {
          this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
        }
        this.loadingShared.hideLoading();
      });
  }

  acceptFollowing(userId: string) {
    this.blogService.setFollowRequest(userId, 'accept').then((res) => {
      if (res.isSuccess()) {
        for (let i = 0; i < this.requests.length; i++) {
          if (this.requests[i].id === userId) {
            this.requests.splice(i, 1);
            break;
          }
        }
        this.requestCount--;
      } else {
        this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
      }
    });
  }

  rejectFollowing(userId: string) {
    this.blogService.setFollowRequest(userId, 'ignore').then((res) => {
      if (res.isSuccess()) {
        for (let i = 0; i < this.requests.length; i++) {
          if (this.requests[i].id === userId) {
            this.requests.splice(i, 1);
            break;
          }
        }
        this.requestCount--;
      } else {
        this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
      }
    });
  }

  profile(username: string) {
    this.selectedUsername = username;
    this.blogService.goToUserProfile(username);

    // this.blogShared.blogZIndex++;
    // this.profileId = this.blogShared.blogZIndex;
    // this.showProfile = true;
    // setTimeout(() => {
    //   document.getElementById('profilePage' + this.id).style.zIndex =
    //     this.blogShared.blogZIndex.toString();
    //   document.getElementById('profilePage' + this.id).style.right = '0';
    // }, 100);
  }

  closeProfile() {
    this.blogShared.blogZIndex--;
    document.getElementById('profilePage' + this.id).style.right = '100%';
    // this._sharedService.animateDownButton();
    this.load();
    setTimeout(() => {
      this.showProfile = false;
    }, 300);
  }
}
